<template>
  <div v-if="tipo && clave">
    <div class="whitePanel">
      <div class="grid">
        <div class="col-12 md:col-4">
          <p class="blueText marginB5Px">{{ label }}</p>
          <InputText
            v-model="filters['filename']"
            class="input"
            id="filename"
            type="text"
            :placeholder="label + '...'"
          />
        </div>
        <div class="col-12 md:col-4">
          <div class="flex">
            <Button
              @click="clearFields()"
              :label="$t('documento.label.limpiar')"
              class="
                buttonStyle
                cleanFilters
                rightAlign
                lightBlueBG
                p-button-lg
              "
            />
          </div>
        </div>
      </div>
    </div>

    <DataTable
      :value="documentos"
      :loading="loading"
      :lazy="true"
      :paginator="true"
      :rows="tamPagina"
      :totalRecords="totalRecords"
      class="p-datatable-responsive"
      :filters.sync="filters"
      selectionMode="single"
      dataKey="id"
      @page="onPage($event)"
      @sort="customSort($event)"
      :autoLayout="true"
    >
      <template #empty>
        {{ noResultsLiteral() }}
      </template>

      <Column
        field="fechaAlta"
        :header="$t('documento.dataTable.fechaAlta')"
        :sortable="true"
      >
        <template #body="slotProps">
          {{ getFormattedDateLong(slotProps.data.fechaAlta) }}
        </template>
      </Column>
      <Column field="filename" :header="label">
        <template #body="slotProps">
          {{ slotProps.data.filename }}
        </template>
      </Column>
      <Column field="base64" :header="$t('documento.dataTable.download')">
        <template #body="slotProps">
          <Button
            @click.prevent="descargarArchivo(slotProps.data.id)"
            icon="pi pi-download"
            iconPos="left"
            v-tooltip.bottom="$t('common.buttons.descargar')"
            class="p-button-text p-button-icon"
          />
        </template>
      </Column>
    </DataTable>
  </div>
</template>


<script>
import DownloadsMixin from "@/utils/downloads";
import DatesMixin from "@/utils/dates";
import MessagesMixin from "@/utils/messages";

import {
  GET_FILES_LIST,
  DOWNLOAD_FILE,
} from "@/graphQLQueries/DocStoreQueries";

import { TIPOS_FICHEROS } from "@/resources/constants";

export const FILTER_SEARCH_FILENAME = "filename";

export default {
  name: "ListadoDocumentos",
  props: ["tipo", "clave", "header", "label", "filename"],
  mixins: [DownloadsMixin, DatesMixin, MessagesMixin],
  data() {
    return {
      numPagina: 0,
      tamPagina: 10,
      sort: ["-fechaAlta"],
      loading: false,
      totalRecords: 0,
      filters: {},
      tiposFichero: TIPOS_FICHEROS,
    };
  },
  created() {
    this.loading = true;
  },
  computed: {
    backendFilters() {
      var filters2 = [];
      filters2.push(`tipo~eq=` + this.tipo);
      filters2.push(`clave~eq=` + this.clave);
      for (let [key, value] of Object.entries(this.filters)) {
        if (value != null && value != undefined && `${value}`) {
          if ([FILTER_SEARCH_FILENAME].includes(key)) {
            filters2.push(`${key}~like=${value}`);
          } else {
            filters2.push(`${key}~eq=${value}`);
          }
        }
      }
      return filters2;
    },
  },
  methods: {
    search() {
      this.loading = true;
      this.$apollo.queries.documentos.refetch();
    },
    onPage(event) {
      this.numPagina = event.page;
    },
    customSort(event) {
      var sortField = event.sortField;
      var sortOrder = event.sortOrder == -1 ? "-" : "";
      var sortToApply = sortOrder + sortField;
      var sorts = [sortToApply];
      this.sort = sorts;
      this.search();
    },
    descargarArchivo(id) {
      this.$apollo
        .query({
          query: DOWNLOAD_FILE,
          variables: {
            id: id,
          },
        })
        .then((data) => {
          var result = data.data.getFileById;
          this.download(result.filename, result.base64, document);
          this.setMessages(
            "success",
            this.$t("documento.mensajes.success.download"),
            3000
          );
        })
        .catch(() => {
          this.setMessages(
            "error",
            this.$t("documento.mensajes.error.download"),
            3000
          );
        });
    },
    clearFields() {
      this.filters = {};
    },
    noResultsLiteral() {
      if (this.tipo == this.tiposFichero.FACTURAS_CLIENTE) {
        return this.$t("documento.dataTable.noInvoices");
      } else {
        return this.$t("common.noResultados");
      }
    },
  },
  apollo: {
    documentos: {
      query: GET_FILES_LIST,
      variables() {
        return {
          criteria: {
            filter: this.backendFilters,
            sort: this.sort,
            page: this.numPagina,
            size: this.tamPagina,
          },
        };
      },
      update(data) {
        let listaDocumentos = data.listaDocumento ? data.listaDocumento.results : null
        if ( listaDocumentos != null)
          listaDocumentos = listaDocumentos.filter((documento) => documento.filename.charAt(8) != 'S')
        this.loading = false;
        this.totalRecords = data.listaDocumento
          ? data.listaDocumento.totalElements
          : null;
          
        return listaDocumentos ? listaDocumentos : null;
      },
      fetchPolicy: "no-cache",
    },
  },
};
</script>


<style lang="scss" scoped>
.cleanFilters {
  margin-top: 39px;
  padding: 8px;
}
</style>